import React from 'react';
import PropTypes from 'prop-types';
import { IconLabel } from 'ctia-ui';
import NavBadge from 'components/MainMenu/NavBadge';

const NavLink = ({ title, glyphIcon, awesomeIcon, badge }) => {
  if (!title) return null;

  const renderBadge = () => {
    if (!badge) return null;
    return <NavBadge badge={badge} />;
  };

  return (
    <span>
      <IconLabel glyph={glyphIcon} awesomeIcon={awesomeIcon} label={title} />
      {renderBadge()}
    </span>
  );
};

NavLink.propTypes = {
  glyphIcon: PropTypes.string,
  awesomeIcon: PropTypes.string,
  title: PropTypes.string.isRequired
};

NavLink.defaultProps = {
  title: ''
};

export default NavLink;



// WEBPACK FOOTER //
// ./src/components/NavLink.js